import { Component, EventEmitter, Query, ViewChild, Output, Input, ViewChildren, ContentChildren, Directive, ElementRef, QueryList, OnInit, trigger, state, animate, style, transition, keyframes, group } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { steppedFly, featuresBox, CartOverlay } from '../../store/animations';
import { showItems }  from '../animations.panels';
import { overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewSwitch, viewOptionList, viewDetails, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow, actionsMenu }  from '../animations.overlay';
import { Http, Response, Headers } from '@angular/http';

import { AppComponent } from '../../app.component';
import { UserService } from '../../services/user.service';
import { StoreService } from '../../services/store.service';
import { environment } from '../../environment';

// Products
import { Account } from '../../models/account';
import { Claim } from '../../models/claim';
import { Order } from '../../models/order';
import { Product } from '../../models/product';
import { News } from '../../models/news';
import { Item } from '../../models/item';

import { Filter } from '../../models/filter.constructor';

declare var $: any

@Component({
  selector: 'user-items', 
  templateUrl: './user.items.html',
  outputs: [ 'giftingitem' ],
  inputs: [ 'reloadClaims' ],
  providers: [ UserService ],
  animations: [ featuresBox, overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, CartOverlay, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewOptionList, viewDetails, viewSwitch, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow, showItems, steppedFly, actionsMenu ]
})
export class UserItemsComponent implements OnInit {

	@Output() giftingitem: EventEmitter<Item> = new EventEmitter();
	@Output() sharelisting: EventEmitter<Item> = new EventEmitter();
	@Input() reloadClaims = false;


	/* Header Tokens */
	public token: any;

	/* Models */
	allitems: Item;
	selected = [];
	toggleItemMenu = null;
	environment = environment;
	showFixture: any;
	fixture: any;
	sort: any;
	cat: any;
	count: any;
	totalItems: any;
	sortOptions: any;
	hasProducts: any;
	accounts: Account;
	products: Product;
	hasItems = false;
	showActions = [];
	selectedItem = 0;
	numberOfItems = 0;
	selectedImage = 0;
	itemquery = new Filter();
	showItemDetails = 'false';
	loadingItemDetails = false;


	constructor(private http : Http,
				private user: UserService,
  			  	private store: StoreService,
				private sanitizer: DomSanitizer) {

		this.hasProducts = 'null';
		this.sortOptions = [
			{ value: 'asc', label: 'Lowest Price' },
			{ value: 'desc', label: 'Highest Price' }
		];

	}
	
	/**
	* Page Handling
	**/

	ngOnChanges(changes) {
		if (changes.reloadClaims) {
			this.fetchUserInfo();
		}
	}

	giftItem(listing) {
		this.giftingitem.emit(listing);
	}

	shareItem(listing) {
		this.sharelisting.emit(listing);
	}

	fetchUserInfo() {
		// Get the users products
		Promise.resolve( this.store.getPurchasedItems() ).then( (i) => {
			if ( !i[0] ) this.hasProducts = 'false';
			if ( i[0] ) this.hasProducts = 'true';
			this.allitems = i;
		}).catch(function (err) { });
	}

	toggleMenu(i) {
		setTimeout( () => { this.toggleItemMenu = i; }, 100);
	}

	inCart() { 
		return false;
	}

	hideDetails() {
		this.showItemDetails = 'false';
	}

	openItem(i) {
		this.selectedItem = i;
		this.showItemDetails = (this.showItemDetails == 'false') ? 'true' : 'false'; 
	}

	hideMenu() {
		if ( this.toggleItemMenu > -1 ) this.toggleItemMenu = null;
	}

	changeSort(selection) { 
		this.itemquery.sort = selection.value;
	}

	isSelected(item) {
		let found = false;
		for (var i = this.selected.length - 1; i >= 0; i--) {
			if (this.selected[i].id == item.id) 
				found = true;
		}
		return found;
	}

	createRange(number) {
		var items: number[] = [];
		for(var i = 1; i <= number; i++) { items.push(i); }		
		return items;
	}


	nextItem() {
		this.selectedImage = 0;
		this.selectedItem = (this.selectedItem < this.totalItems-1) ? this.selectedItem+1 : this.selectedItem;
	}

	prevItem() {
		this.selectedImage = 0;
		this.selectedItem = (this.selectedItem > 0) ? this.selectedItem-1 : 0;
	}

	/* On with the show */
	ngOnInit() {
		this.user.authorizeUser().subscribe( (usr) =>  {
			if ( usr ) {
				this.accounts = usr;

				if ( this.accounts[0].items > 0 ) {
					this.numberOfItems = this.accounts[0].items+1;
				}

			}
		});
		this.fetchUserInfo();
	}
	
	ngForCallback(i) {

	}


}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/user-items/user.items.component.ts